/* Low Tide säljsida: flikar/karusell, paketval → Subscribe & Save + gåvor, fast knapp på mobil */
(function () {
  function money(c, fmt) { return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)); }

  // Karusell + flikar: alla kort i en bana, flik = hoppa till kategori, svep/dra/pilar
  var car = document.querySelector('[data-lts-car]');
  if (car) {
    var track = car.querySelector('[data-track]'), dotsEl = car.querySelector('[data-dots]');
    var tabs = [].slice.call(document.querySelectorAll('[data-lts-tabs] button'));
    var cards = [].slice.call(track.children);
    cards.forEach(function (c) { c.classList.remove('is-hidden'); });
    dotsEl.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
    var n = cards.length, cur = 0, prog = false;
    function step() { return n > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : (cards[0] ? cards[0].offsetWidth : 1); }
    function maxLeft() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function norm(s) { return String(s || '').trim().toLowerCase(); }
    function upd() {
      [].forEach.call(dotsEl.children, function (d, j) { d.classList.toggle('is-on', j === cur); });
      cards.forEach(function (c, j) { c.classList.toggle('is-cur', j === cur); });
      var cat = cards[cur] ? norm(cards[cur].dataset.cat) : '';
      tabs.forEach(function (t) { t.classList.toggle('is-on', norm(t.dataset.tab) === cat); });
    }
    function goTo(i) {
      cur = ((i % n) + n) % n; prog = true; upd();
      track.scrollTo({ left: Math.min(cur * step(), maxLeft()), behavior: 'smooth' });
      clearTimeout(track.__p); track.__p = setTimeout(function () { prog = false; }, 700);
    }
    track.addEventListener('scroll', function () {
      if (prog) return;
      clearTimeout(track.__t); track.__t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / step()), atEnd = track.scrollLeft >= maxLeft() - 4;
        if (!(atEnd && cur >= i)) cur = Math.min(i, n - 1);
        upd();
      }, 80);
    }, { passive: true });
    car.querySelector('[data-prev]').addEventListener('click', function () { goTo(cur - 1); });
    car.querySelector('[data-next]').addEventListener('click', function () { goTo(cur + 1); });
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = cards.findIndex(function (c) { return norm(c.dataset.cat) === norm(t.dataset.tab); });
        if (k >= 0) goTo(k);
      });
    });
    // Dra med musen på dator (pekskärm sveper redan)
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.style.scrollSnapType = 'none'; track.style.cursor = 'grabbing'; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; track.style.cursor = ''; track.style.scrollSnapType = ''; if (moved) goTo(Math.round(track.scrollLeft / step())); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    upd();
  }

  // Erbjudandet
  var offer = document.querySelector('[data-lts-offer]');
  if (offer) {
    var fmt = offer.dataset.moneyFormat, packs = offer.querySelectorAll('.lts-pack'), btn = offer.querySelector('[data-lts-atc]');
    function sel(p) {
      packs.forEach(function (x) { x.classList.remove('is-on'); }); p.classList.add('is-on');
      offer.querySelector('[data-now]').textContent = money(+p.dataset.price, fmt);
      offer.querySelector('[data-cmp]').textContent = +p.dataset.compare ? money(+p.dataset.compare, fmt) : '';
    }
    packs.forEach(function (p) { p.addEventListener('click', function () { sel(p); }); });
    sel(offer.querySelector('.lts-pack.is-on') || packs[0]);
    btn.addEventListener('click', function () {
      var p = offer.querySelector('.lts-pack.is-on'); btn.disabled = true;
      var items = [{ id: +p.dataset.variant, quantity: 1 }];
      if (offer.dataset.plan) items[0].selling_plan = +offer.dataset.plan;
      (p.dataset.gifts || '').split(',').forEach(function (g) { if (g.trim()) items.push({ id: +g, quantity: 1, properties: { _gift: 'Free gift' } }); });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw 0; window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; });
    });
  }

  // Fast knapp på mobil: visas efter heron, döljs vid erbjudandet
  var st = document.querySelector('[data-lts-sticky]'), hero = document.querySelector('.lts-hero');
  if (st && hero && 'IntersectionObserver' in window) {
    var heroOut = false, offerIn = false;
    function set() { st.classList.toggle('is-on', heroOut && !offerIn); }
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; set(); }).observe(hero);
    var offEl = document.getElementById('offer'); if (offEl) offEl = offEl.closest('.shopify-section') || offEl; if (offEl) new IntersectionObserver(function (e) { offerIn = e[0].isIntersecting; set(); }).observe(offEl);
  }
})();
/* Nedräkning mot rean:s riktiga slutdatum (sätts i "LTS – Erbjudandeband") */
(function () {
  document.querySelectorAll('[data-lts-deadline]').forEach(function (row) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(row.dataset.ltsDeadline || ''); if (!m) { row.hidden = true; return; }
    // New York-tid (EDT/EST) → UTC
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] + 4, +m[5]);
    var month = +m[2]; var end = (month > 3 && month < 11) ? guess : guess + 3600000;
    var el = row.querySelector('[data-lts-timer]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { row.hidden = true; return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mi = Math.floor(s % 3600 / 60), se = s % 60;
      el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(se);
    }
    tick(); setInterval(tick, 1000);
  });
})();

// Recensionsvideor: klick på play spelar videon (endast kort med uppladdad video)
document.querySelectorAll('[data-lts-vid]').forEach(function (f) {
  var v = f.querySelector('video'); if (!v) return;
  f.addEventListener('click', function () {
    if (v.paused) { document.querySelectorAll('[data-lts-vid] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-lts-vid]').classList.remove('is-playing'); } }); v.controls = true; v.play(); f.classList.add('is-playing'); }
  });
  v.addEventListener('ended', function () { f.classList.remove('is-playing'); v.controls = false; });
});

// Recensioner: Read More / Show Fewer + mobilkarusell för videorna
document.querySelectorAll('[data-lts-moretoggle]').forEach(function (btn) {
  var box = btn.closest('.lts-wrap').querySelector('[data-lts-more]');
  btn.addEventListener('click', function () {
    var open = box.hasAttribute('hidden');
    if (open) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
    btn.textContent = open ? btn.dataset.less : btn.dataset.more;
  });
});
document.querySelectorAll('[data-lts-vids]').forEach(function (g) {
  var nav = g.nextElementSibling; if (!nav || !nav.classList.contains('lts-vids__nav')) return;
  var dots = nav.querySelectorAll('.lts-vids__dots i'), items = g.children;
  function idx() { var w = items[0].offsetWidth + 13; return Math.round(g.scrollLeft / w); }
  function go(i) { var n = items.length; i = (i + n) % n; g.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); }
  nav.querySelector('[data-vprev]').addEventListener('click', function () { go(idx() - 1); });
  nav.querySelector('[data-vnext]').addEventListener('click', function () { go(idx() + 1); });
  g.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }, { passive: true });
});

/* 15-minutersreservation: äkta rabattkod som bara läggs på inom besökarens fönster.
   Nytt fönster först när "cooldown" timmar gått sedan förra fönstret tog slut. */
(function () {
  var rows = document.querySelectorAll('[data-lts-resv]'); if (!rows.length) return;
  var test = rows[0].dataset.test === '1';
  if (test) {
    if (!((window.Shopify && Shopify.designMode) || /[?&]lt_timer_test=1/.test(location.search))) return;
    rows.forEach(function (r) { r.hidden = false; var dl = r.parentNode.querySelector('[data-lts-deadline]'); if (dl) dl.remove(); });
  }
  var r0 = rows[0], code = r0.dataset.code, win = (+r0.dataset.minutes || 15) * 60000, cool = (+r0.dataset.cooldown || 24) * 3600000;
  var KEY = test ? 'lt_resv_test' : 'lt_resv_v1', now = Date.now(), st = null;
  try { st = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!st || st.code !== code || now > st.start + win + cool) { st = { start: now, code: code }; try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  var end = st.start + win, root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  function setDiscount(c) {
    return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: c }) }).catch(function () {});
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  var applied = false, cleared = false;
  function tick() {
    var s = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    rows.forEach(function (row) {
      row.querySelector('[data-lts-timer]').textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      row.querySelector('[data-lts-resv-label]').textContent = s > 0 ? row.dataset.label : row.dataset.ended;
      row.classList.toggle('is-ended', s <= 0);
    });
    if (test) { applied = cleared = true; }
    if (!test) window.ltResvCode = s > 0 ? code : '';
    if (s > 0 && !applied) { applied = true; setDiscount(code); document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/; max-age=' + Math.ceil(s); }
    if (s <= 0 && !cleared) { cleared = true; setDiscount(''); document.cookie = 'discount_code=; path=/; max-age=0'; clearInterval(iv); }
  }
  var iv = setInterval(tick, 1000); tick();
  // Lägg på koden igen precis före köp om fönstret fortfarande är öppet (varukorgen kan ha skapats efter sidladdning)
  document.addEventListener('click', function (e) { if (e.target.closest('[data-atc]') && Date.now() < end) setTimeout(function () { setDiscount(code); }, 1500); }, true);
})();
